// extracted by mini-css-extract-plugin
export var button = "_ai-0";
export var icon = "_ai-1";